// Copy centralizado de la seccion "Docentes" (solo ADMIN). Ver nota de i18n en
// features/fichas/copy.ts. Claves en ingles, copy en espanol.

export const docentesCopy = {
  sectionTitle: 'Docentes',
  sectionDescription:
    'Creá y gestioná docentes del panel. La baja es reversible y conserva sus fichas.',
  newDocente: 'Nuevo docente',
  columns: {
    nombre: 'Nombre',
    apellido: 'Apellido',
    email: 'Email',
    username: 'Usuario',
    alta: 'Fecha de alta',
    estado: 'Estado',
    suspension: 'Fecha de suspensión',
    publicar: 'Puede publicar',
    acciones: 'Acciones',
  },
  status: {
    active: 'Activo',
    suspended: 'Suspendido',
  },
  publish: {
    on: 'Sí',
    off: 'No',
    // aria-label del toggle en la fila.
    toggleAria: (name: string): string => `Permitir publicar a ${name}`,
    grantedToast: 'Permiso de publicar otorgado',
    revokedToast: 'Permiso de publicar revocado',
    error: 'No pudimos cambiar el permiso de publicar.',
  },
  filters: {
    status: 'Estado',
    all: 'Todos',
    active: 'Activos',
    suspended: 'Suspendidos',
  },
  actions: {
    suspend: 'Dar de baja',
    reactivate: 'Dar de alta',
    edit: 'Editar',
    cancel: 'Cancelar',
    save: 'Guardar',
    create: 'Crear docente',
  },
  form: {
    createTitle: 'Nuevo docente',
    createDescription:
      'Se crea la cuenta de acceso al panel. Podés cambiar estos datos más adelante.',
    editTitle: 'Editar docente',
    editDescription: 'Actualizá los datos del docente. Dejá la contraseña vacía para no cambiarla.',
    nombre: 'Nombre',
    apellido: 'Apellido',
    email: 'Email',
    password: 'Contraseña',
    passwordHint: 'Mínimo 8 caracteres.',
    passwordEditHint: 'Dejala vacía para mantener la actual.',
    passwordConfirm: 'Confirmar contraseña',
    passwordMismatch: 'Las contraseñas no coinciden.',
    canPublish: 'Puede publicar fichas',
    canPublishHint: 'Si está apagado, el docente solo guarda borradores.',
    createdToast: 'Docente creado',
    updatedToast: 'Docente actualizado',
    createError: 'No pudimos crear el docente.',
    updateError: 'No pudimos actualizar el docente.',
    emailTaken: 'Ya existe una cuenta con ese email.',
    passwordTooShort: 'La contraseña debe tener al menos 8 caracteres.',
    required: 'Completá los campos obligatorios.',
  },
  empty: {
    title: 'No hay docentes',
    description: 'Todavía no hay docentes cargados en el sistema.',
  },
  suspendDialog: {
    title: 'Dar de baja al docente',
    confirm: (name: string): string =>
      `${name} perderá acceso al panel. Sus fichas publicadas se conservan. Podés darlo de alta cuando quieras.`,
  },
  reactivateDialog: {
    title: 'Dar de alta al docente',
    confirm: (name: string): string => `${name} volverá a tener acceso al panel.`,
  },
  toasts: {
    suspended: 'Docente dado de baja',
    reactivated: 'Docente dado de alta',
    suspendError: 'No pudimos dar de baja al docente.',
    reactivateError: 'No pudimos dar de alta al docente.',
    loadError: 'No pudimos cargar los docentes.',
  },
} as const
